import React from 'react'

import { HStack, Icon, T, VStack } from 'src/govwell-ui'

type Props = {
  onClose: () => void
}

const StaffAIChatHeader = ({ onClose }: Props) => (
  <div className="shrink-0 border-b border-neutral-200 bg-white px-6 py-4">
    <HStack gap={3}>
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-neutral-900">
        <Icon.FaSparkles className="h-5 w-5 text-white" />
      </div>
      <VStack gap={0}>
        <HStack gap={2}>
          <T.Body className="font-semibold text-neutral-900">New Conversation</T.Body>
          <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-700">
            Beta
          </span>
        </HStack>
        <T.BodySmall className="text-neutral-500">GovWell AI Assistant</T.BodySmall>
      </VStack>
      <div className="flex-1" />
      <button
        type="button"
        onClick={onClose}
        className="flex cursor-pointer items-center justify-center rounded-lg border-none bg-transparent p-2 text-neutral-500 transition-colors hover:bg-neutral-100 hover:text-neutral-700"
        aria-label="Close"
      >
        <Icon.FaXmark className="h-5 w-5" />
      </button>
    </HStack>
  </div>
)

export default React.memo(StaffAIChatHeader)
